export default function ({ i18n, $moment }) {
  i18n.onLanguageSwitched = (oldLocale, newLocale) => {
    $moment.locale(newLocale)
  }
}
